import { Clock } from "lucide-react";
import { fmtEuro } from "@/lib/api";
import { useLookups } from "@/lib/useLookups";
import CatalogPage from "@/pages/CatalogPage";
import { Field, inputCls } from "@/components/common";

export default function Treatments() {
  const { treatments, reload } = useLookups(["treatments"]);
  return (
    <CatalogPage resource="treatments" overline="Listino" title="Trattamenti" singular="Trattamento" testPrefix="treatments" items={treatments} reload={reload}
      blank={{ name: "", category: "", duration: 60, price: 0, description: "" }}
      fields={(f, set) => (
        <>
          <Field label="Nome *"><input className={inputCls} value={f.name} onChange={(e) => set({ ...f, name: e.target.value })} data-testid="treatment-name-input" /></Field>
          <Field label="Categoria"><input className={inputCls} placeholder="Viso, Corpo…" value={f.category} onChange={(e) => set({ ...f, category: e.target.value })} data-testid="treatment-category-input" /></Field>
          <Field label="Durata (min)"><input type="number" min="5" step="5" className={inputCls} value={f.duration} onChange={(e) => set({ ...f, duration: e.target.value })} data-testid="treatment-duration-input" /></Field>
          <Field label="Prezzo (€)"><input type="number" min="0" step="0.5" className={inputCls} value={f.price} onChange={(e) => set({ ...f, price: e.target.value })} data-testid="treatment-price-input" /></Field>
          <div className="sm:col-span-2"><Field label="Descrizione"><textarea rows={2} className={inputCls} value={f.description} onChange={(e) => set({ ...f, description: e.target.value })} data-testid="treatment-description-input" /></Field></div>
        </>
      )}
      renderCard={(t) => (
        <div>
          {t.category && <div className="text-[10px] uppercase tracking-[0.2em] text-[#C5A059] mb-1">{t.category}</div>}
          <div className="font-serif text-2xl text-[#121212]">{t.name}</div>
          {t.description && <p className="mt-1 text-sm text-[#6E675F] line-clamp-2">{t.description}</p>}
          <div className="mt-4 flex items-center justify-between">
            <span className="flex items-center gap-1 text-sm text-[#6E675F]"><Clock className="h-3.5 w-3.5" />{t.duration} min</span>
            <span className="font-serif text-2xl text-[#121212]">{fmtEuro(t.price)}</span>
          </div>
        </div>
      )} />
  );
}
